import Reflux                     from 'reflux';
import DescriptorActions          from 'actions/descriptor_actions';
import Compiler                   from 'descriptor/compiler';
import StoreState                 from 'mixins/store_state';
import HasPrettyTime              from 'mixins/has_pretty_time';
import ChapterActions             from 'actions/chapter_actions';

export default Reflux.createStore({
  mixins: [ StoreState, HasPrettyTime ],
  listenables: DescriptorActions,
  stateNamespace: 'descriptor',
  defaultVideoOptions: {
    shouldShowControlsDesktop: true,
    shouldShowNativeControlsMobile: true,
    shouldAutoPlay: false,
    watermark: null
  },
  onLoadJSON(descriptor) {
    this.compile(descriptor);
  },
  getTitle(index) {
    return this.state.videos[index].title;
  },
  getDescriptor() {
    return this.state;
  },
  isVideo() {
    return this.state.isVideo;
  },
  getInitialIndex() {
    return  this.state.initialIndex;
  },
  getVideo(index) {
    return this.state.videos[index];
  },
  getCCFileRoot() {
    return this.state.config.ccFileRoot;
  },
  hasCCEnabled(index) {
    return this.state.videos[index].hasCc;
  },
  getCCInfo() {
    return this.state.ccInfo;
  },
  getCCArray(index) {
    return this.state.videos[index].ccInfo;
  },
  getVideos() {
    return this.state.videos;
  },
  getVideoCount() {
    return this.state.videos.length;
  },
  getCCDefaultLang() {
    return this.state.config.ccDefaultLang;
  },
  compile(descriptor) {
    const compiler = new Compiler(descriptor);
    compiler.compile();
    this.setState(compiler.getDescriptor());
    ChapterActions.loadLocks(compiler.getDescriptor().lockChildren);
  }
});



// WEBPACK FOOTER //
// ./modules/stores/descriptor_store.js